module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjYxNTY0IDUuMzYzODlDNS4yMzE1MSA1LjcyMjE1IDQuNjM1NjggNS43MjIxNSA0LjI1MTU1IDUuMzYzODlMMS4xNjA3NyAyLjQ4MTMxQzAuNDk2ODkyIDEuODYyMTQgMC45MzUwMjEgMC43NSAxLjg0MjgyIDAuNzVIOC4wMjQzN0M4LjkzMjE3IDAuNzUgOS4zNzAyOSAxLjg2MjE0IDguNzA2NDEgMi40ODEzMUw1LjYxNTY0IDUuMzYzODlaIiBmaWxsPSIjREREREREIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history/arrowRotate.svg
// module id = ne1E
// module chunks = 0